import { WidgetAvaliacao } from './components/WidgetAvaliacao'
import type { AvaliacaoAppProps } from './avaliacao-app.props'

export default class AvaliacaoApp {
    constructor({
        id,
        avaliacoes,
        titulo
    }: AvaliacaoAppProps){
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <WidgetAvaliacao avaliacoes={avaliacoes} titulo={titulo} />
        )
    }
}
